import { isIntegerControl, isStringControl, or, rankWith } from "@jsonforms/core";

export default rankWith(3, or(isStringControl, isIntegerControl));
